module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAS5JREFUeNpiYBiKoAOInwLxfxz4FhCXkmKgL1TjeSDeD6WR+SB8Hyo2n1hDVwLxDyDmh/IdoAY4IKkBye0l1mBxqMIFSGLYDAUBZiBeCJVbCOVjABYgjoWyXyAZYoBGI4P5UPE4IJYB4kggfoWu6DyeyCEWrwXiQJiBjFDBG0DcTmaqsQXiUGiYOwLxAQaoofspTI6cUAMZYQLohtoBcQMQe1FiC8jQY1B2JlpYERMkOkjqN8AEN0AFLgLxe2giB6WCa1D+fix4OpKhsLT7AYglYUkqBojLoAEuB017bFCMC3yG0mFA7ARlg7J4G7bkFY3m/UwCXr+NJXntw6ZQA4iLgNiIiPCMgEbqPqSyQoBaJdx2IH4JzfJUAaDI+QnEJtQsh9OAOHhI1iAMAAEGAKZ9aKLfWO4EAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/electric-caricon.png
// module id = x8+w
// module chunks = 0